import React from 'react';
import TextField from '@material-ui/core/TextField';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import CheckBoxOutlineBlankOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
// import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
// import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckIcon from '@material-ui/icons/Check';
// import FlagIcon from '@material-ui/icons/Flag';
import PlayArrowOutlinedIcon from '@material-ui/icons/PlayArrowOutlined';
import UpdateIcon from '@material-ui/icons/Update';

import TaskList from "./TaskList";

import './TodoList.css';

import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import {Tooltip} from "@material-ui/core";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {enGB} from 'date-fns/locale'

import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationDialog from "../components/ConfirmationDialog";

/**
 * props:
 * element
 * ...
 */
class TodoList extends React.Component {
    // TODO Duplicated from TodoLists
    dateOptions = {weekStartsOn:1};

    constructor(props) {
        super(props);
        // console.log("TodoList:", props);
        this.ref = React.createRef();

        this.state = {
            onlyTitle: false,
            editName: this.props.create,
            edit: false,
            expanded: props.selected,
            updatedTime: new Date(),
        };

        this._handleTextFieldChange = this._handleTextFieldChange.bind(this);
        this._handleDateChange = this._handleDateChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);

        this.remove = this.remove.bind(this);
        this.removeCancel = this.removeCancel.bind(this);
        this.removeOK = this.removeOK.bind(this);

        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);

        this.createTask = this.createTask.bind(this);
        this.removeTask = this.removeTask.bind(this);
        this.updateTasks = this.updateTasks.bind(this);

        this.styles = props.styles;
    }

    componentDidMount() {
        if(this.props.selected) {
            console.info("TodoList.componentDidMount: scrollTo", this.props.element.id, ", offset", this.ref.current.offsetTop);
            window.scrollTo(0, this.ref.current.offsetTop - 76);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!prevProps.selected && this.props.selected && !this.state.expanded) {
            this.setState({expanded: true});

            // TODO Only scroll to component if it did move in the timeline. Check prevProps vs props.
            // console.log("TodoList group changed from", prevProps.groupName, "to", this.props.groupName);
            // if(prevProps.groupName !== this.props.groupName) {
                console.info("TodoList.componentDidUpdate: scrollTo", this.props.element.id, ", offset", this.ref.current.offsetTop);
                window.scrollTo(0, this.ref.current.offsetTop - 76);
            // }
        }
    }

    render() {
        const element = this.props.element;
        const changed = this.state;

        let description;
        if(changed.description !== null && changed.description !== undefined) {
            description = changed.description;
        } else if(element.description) {
            description = element.description;
        } else {
            description = "";
        }

        const values = {
            name: changed.name || element.name,
            description: description,
            status: changed.status || element.status,
            assigned: changed.assigned || (element.assigned && element.assigned[0] ? element.assigned[0] : undefined),
            version: this.state.version,
        };

        const elementStatus = this.state.status || element.status;
        let openTasks = this.countOpenTasks();
        let cssClass = this.css(element, openTasks);

        // // If you push Later in Do mode, the card will disappear before you have a chance to select a plannedDate.
        // let showLater = !this.props.filter.openTasks;
        // console.log("TodoList showLater:", showLater);

        let statusButtons =
            <div className="status-buttons">
                <ToggleButtonGroup
                    value={elementStatus}
                    exclusive
                    onChange={this.handleStatusChange}
                >
                    <ToggleButton value="Done">Ready</ToggleButton>
                    <ToggleButton value="To do">To do</ToggleButton>
                    <ToggleButton value="Future">Later</ToggleButton>
                </ToggleButtonGroup>
                {elementStatus === "Future" &&
                <div className="planned-start">
                    {/* Use MuiPickersUtilsProvider locale to start week on Monday in dialog. */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enGB}>
                        <DatePicker
                            className='date-edit'
                            format="yyyy-MM-dd"
                            clearable={true}
                            showTodayButton={true}
                            label={element.plannedStart ? undefined : "Set date..."}
                            value={element.plannedStart ? element.plannedStart : null}
                            onChange={this._handleDateChange}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                }
            </div>;

        let statusSymbol = this.statusSymbol(element.status2, openTasks);

        return (
            <Accordion
                ref={this.ref}
                expanded={this.state.expanded}
                onChange={(event, isExpanded) => {
                    console.log("TodoList set expanded to", isExpanded, ", was selected:", this.props.selected);
                    this.setState({expanded: isExpanded});
                    // FIXME This reveals hidden groups some times.
                    // if(isExpanded !== this.props.selected) {
                    //     console.log("TodoList expand: select", this.props.element);
                    //     this.props.select(isExpanded && this.props.element);
                    // }
                }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={"title " + cssClass}
                >
                    {statusSymbol}
                    {this.state.edit || this.state.editName ?
                        <div style={{width: '100% !important'}}>
                            <TextField id='name'
                                       className="todo-name-edit"
                                       value={values.name}
                                       onChange={this._handleTextFieldChange}
                                       onClick={(event) => {event.stopPropagation()}}
                                       onFocus={(event) => event.stopPropagation()}
                                       autoFocus={true}
                                       InputProps={{
                                           style: {
                                               fontWeight: 'bold',
                                               marginTop: 2,  // Wrong when te accordion is expanded
                                           }
                                       }}
                            />
                        </div>
                        :
                        <span className="name-read">
                            {values.name}
                        </span>
                    }
                </AccordionSummary>
                <AccordionDetails>
                    <div className={"content " + cssClass}>
                        {this.state.edit ?
                            <div className="editor">
                                <TextField id='description'
                                           variant="outlined"
                                           fullWidth
                                           multiline
                                           autoFocus={true}
                                           value={values.description}
                                           onChange={this._handleTextFieldChange}
                                           InputProps={{
                                               style: {
                                                   fontSize: '15px',
                                               }
                                           }}
                                />
                            </div> :
                            <div className="description-read">
                                {
                                    values.description.split('\n').map((line, index) =>
                                        line ?
                                            <div key={index}>{line}</div> :
                                            <span key={index}/>
                                    )
                                }
                            </div>
                        }
                        {statusButtons}
                        <div className="taskList">
                            <TaskList
                                metamodel={this.props.metamodel}
                                globals={this.props.globals}
                                parent={element}
                                user={this.props.user}
                                users={this.props.users}
                                showDetails={false}
                                userMap={this.props.userMap}
                                filter={this.props.filter}
                                createTask={!this.state.edit && this.createTask}
                                removeTask={this.removeTask}
                                updateTasks={this.updateTasks}
                                showHeader={false}
                            />
                        </div>
                        {this.state.edit &&
                            <Tooltip title="Delete" className="delete">
                                <IconButton aria-label="delete" onClick={this.remove}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {!this.state.edit &&
                            <div className="edit">
                                <Tooltip title="Edit">
                                    <IconButton aria-label="edit"
                                                onClick={() => this.setState({edit: true})}>
                                        <EditOutlinedIcon/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                        {this.state.edit &&
                            <div className="edit-buttons">
                                <IconButton aria-label="cancel"
                                            onClick={this.cancel}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <IconButton aria-label="ok"
                                            onClick={this.save}
                                >
                                    <DoneIcon />
                                </IconButton>
                            </div>
                        }
                        <ConfirmationDialog
                            title={"Remove card"}
                            text={"Remove '" + this.props.element.name + "'?"}
                            open={this.state.confirmationOpen}
                            onOK={this.removeOK}
                            onCancel={this.removeCancel}
                        />
                    </div>
                </AccordionDetails>
            </Accordion>
        );
    }

    statusSymbol(status, openTasks) {
        if(status === 'To do') {
            if(openTasks > 0) {
                // return <AccountBoxOutlinedIcon className="status-symbol"/>;
                return <CheckBoxOutlineBlankOutlined className="status-symbol"/>;
            } else {
                // return <CheckBoxOutlineBlankOutlined className="status-symbol"/>;
                // return <CheckBoxOutlineBlankOutlined className="hide"/>;
                return <PlayArrowOutlinedIcon className="status-symbol hide"/>;
            }
        } else if(status === 'Done') {
            // return <CheckBoxOutlinedIcon className="status-symbol"/>;
            return <CheckIcon className="status-symbol"/>;
        } else if(status === 'Future') {
            return <UpdateIcon className="status-symbol"/>;
        } else {
            console.log("TodoLists: Unknown status:", status);
            return <CheckBoxOutlineBlankOutlined className="status-symbol"/>;
        }
    }

    cancel() {
        this.setState({
            editName: false,
            edit: false,
            name: undefined,
            type: undefined,
            description: undefined,
            status: undefined,
            assigned: undefined,
        });
        if(this.props.onCancel) {
            this.props.onCancel();
        }
    }

    save() {
        console.log("save element:", this.props.element, "state:", this.state);

        if(this.props.create) {
            let values = {
                name: this.state.name || this.props.element.name,
                description: this.state.description,
                status: this.state.status || this.props.element.status,
                assigned: this.state.assigned,
            };
            this.saveNewElement(values);
        } else {
            let values = {
                name: this.state.name,
                description: this.state.description,
                status: this.state.status,
                assigned: this.state.assigned,
            };
            this.updateElement(values);
        }
    }

    updateElement(values) {
        const element = this.props.element;

        return this.props.globals.updateElement(element, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    Object.assign(element, result);
                    this.cancel();
                    // FIXME When changing plannedDate, this reveals Completed tasks.
                    // this.props.select(this.props.element);
                    this.props.refresh && this.props.refresh();
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    createTask(values) {
        let parent = this.props.element;
        let collection = "tasks";

        console.log("TodoList createTask parent:", parent, "collection:", collection, "values:", values);

        return this.props.globals.createChild(parent, collection, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    parent.tasks.push(result);
                    this.updateTasks();
                },
                (error) => {
                    console.error(error);
                }
            )
    };

    removeTask(element) {
        // TODO Confirm or undo remove task.
        let parent = this.props.element;

        console.log("TodoList.removeTask", element);

        this.props.globals.deleteElement(element)
            .then(
                (result) => {
                    console.log("Result", result);
                    let ix = parent.tasks.indexOf(element);
                    console.log("index:", ix);
                    delete parent.tasks[ix];
                    this.updateTasks();
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    updateTasks() {
        console.log("TodoList.updateTasks");
        this.setState({updatedTime: new Date()});
        this.props.refresh && this.props.refresh();
        // FIXME
        // this.props.select(this.props.element);
    }

    handleStatusChange(event, newStatus) {
        // const element = this.props.element;

        let values = {
            status: newStatus,
            archiveTime: null,
        };

        if(newStatus === 'Done') {
            // let weekStart = startOfWeek(new Date(), this.dateOptions);
            // let nextWeek = addDays(weekStart, 7);
            // values.archiveTime = nextWeek;
            values.archiveTime = new Date();
            console.log("TodoList done now:", new Date(), ", archiveTime:", values.archiveTime);
        }

        const saveLater = this.state.edit || this.props.create;
        if(saveLater) {
            console.log("setState:", values);
            this.setState(values);
        } else {
            this.updateElement(values).then(
                () => {
                    this.setState({
                        version: new Date().getTime()
                    });
                    this.props.select(this.props.element);
                    this.props.refresh && this.props.refresh();
                }
            );
        }
    }

    _handleTextFieldChange(e) {
        // console.log("_handleTextFieldChange", e.target.id, e.target.value);
        let newState = {};
        newState[e.target.id] = e.target.value;
        this.setState(newState);
    }

    _handleDateChange(date, value) {
        console.log("_handleDateChange", date instanceof Date && !isNaN(date), date, value);

        this.setState({date: date, edit: false});
        if(date instanceof Date && !isNaN(date)) {
            // If I clear state here, it shows the date before for some reason, so don't do that.
            this.updateElement({plannedStart: date});
        } else {
            this.updateElement({plannedStart: null});
        }
    }

    remove() {
        this.setState({confirmationOpen: true} );
    }

    removeCancel() {
        this.setState({confirmationOpen: false} );
    }

    removeOK() {
        this.props.remove(this.props.element);
        this.setState({confirmationOpen: false} );
    }

    countOpenTasks() {
        let element = this.props.element;
        let userId = this.props.user.id;

        // TODO This happens with Done cards. But should it, or should we get those tasks too?
        if(!element.tasks) {
            return 0;
        }

        return element.tasks.filter(task =>
            task.status === 'To do' && task.assigned.length === 1 && task.assigned[0].id === userId
        ).length;
    }

    css(element, openTasks) {
        if((element.status2 || element.status) === 'To do' && openTasks === 0) {
            return 'nothing-todo';
        }

        let status = element.status2 || element.status;
        let cssClasses = {
            'Done': 'done',
            'In progress': 'todo',
            'To do': 'todo',
            'Future': 'future'
        }
        return cssClasses[status];
    }
}

export default TodoList;